import { Typography } from '@mui/material';
import React from 'react';
import { FilterItemProps } from './FilterItemDisplay';

const SelectorFilterItem = ({ filter }: FilterItemProps) => {
    return <Typography>{filter.value}</Typography>;
};

export default SelectorFilterItem;
